// Dependencies
require("webstrap/type");

// Copy images
require("!!asset!./img/logo.png");

// Styles
require("./footer.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/footer/index.js
 ** module id = 83
 ** module chunks = 0 1
 **/